<template>
  <el-select clearable :value="value" @change="selOptionChange" placeholder="请选择组织">
    <el-option v-for="item in orgList" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"></el-option>
  </el-select>
</template>
<script>
export default {
  props: ['value'],
  data () {
    return {
      orgList: []
    }
  },
  created () {
    this.getOrgList()
  },
  watch: {

  },
  methods: {
    getOrgList () {
      const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/list'
      this.HttpService.post(url, {}).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          const resData = res.data || []
          this.orgList = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    selOptionChange (value) {
      this.$emit('input', value)
      const selectedObj = this.orgList.find(item => item.partnershipId === value)
      this.$emit('change', selectedObj)
    }
  }
}
</script>
<style scoped lang='scss'></style>


// WEBPACK FOOTER //
// src/components/BelongOrgSelect/index.vue